//引入封装好的 service
import service from "@/service/service";
import { nameToNumeric } from "@/utils";

//声明一个基础接口变量
const baseURL = `${import.meta.env.VITE_APP_STARNEST_API}/app-api/`;
const baseAdminURL = `${import.meta.env.VITE_APP_STARNEST_API}/admin-api/`;
const amaxNodeApi = `${import.meta.env.VITE_APP_URL}`;

//设置请求头（如果请求头统一的话可以在axios文件设置，则无须从这里传过去）
export const header = {
  Accept: 'application/json;charset=UTF-8',
}

const fileHeader = {
  Accept: 'multipart/form-data',
}

//根据自身需求
const _service={
    getProductCategoryList() {
      const url = baseURL + `product/category/list-by-ids`;
      return service.get(url, {ids:'1,2'}, header);
    },
    getProductByCategoryId(params:any) {
      const url = baseURL + `product/spu/page`;
      return service.get(url, params, header);
    },
    getIntegralProductList(params:any) {
      const url = baseURL + `product/spu/page`;
      return service.get(url, params, header);
    },
    getTokenList(data:any){
      const url = baseURL + `/v1/pg/get/tokens`
      return service.post(url, data, header);
    },
    getUserInfo(params:any){
      const url = baseURL + `member/user/get`
      return service.get(url, params, header);
    },
    getProductDetail(params:any){
      const url = baseURL + `product/spu/get-detail`
      return service.get(url, params, header);
    },
    createStarOrder(data:any){
      const url = baseURL + `trade/order/create`
      return service.post(url, data, header);
    },
    // getPayChannel(params:any){
    //   const url = baseURL + `pay/channel/get-enable-code-list`
    //   return service.get(url, params, header);
    // },
    integralPay(data:any){
      const url = baseURL + `pay/transaction/integral-package`
      return service.post(url, data, header);
    },
    getRates(){
      const url = `${import.meta.env.VITE_APP_STARNEST_API}/api/starnest/v1/wallet/tokens/rates`
      return service.get(url, {}, header);
    },
    getPayChannel(data:any){
      const url = baseURL + `pay/channel/list`
      return service.post(url, data, header);
    },
    getPayChannelSort(data:any){
      const url = baseURL + `pay/channel/channel-sort`
      return service.post(url, data, header);
    },
    getOrderPayStatus(params:any){
      const url = baseURL + `pay/order/status`
      return service.get(url, params, header);
    },
    submitOrder(data:any){
      const url = baseURL + `pay/order/submit`
      return service.post(url, data, header);
    },
    loginH5(data:any){
      const url = baseURL + `member/auth/h5/login`
      return service.post(url, data, header);
    },
    specialLogin(data:any){
      const url = baseURL + `member/auth/specialLogin`
      return service.post(url, data, header);
    },
    getSmsCode(data:any){
      const url = baseURL + `member/auth/getSmsCode`
      return service.post(url, data, header);
    },
    getTransferLog(data:any){
      const url = baseURL + `member/auth/getTransferLog`
      return service.post(url, data, header);
    },
    getCaptcha(data:any){
      const url = baseAdminURL + `system/captcha/get`
      return service.post(url, data, header);
    },
    checkCaptcha(data:any){
      const url = baseAdminURL + `system/captcha/check`
      return service.post(url, data, header);
    },
    getAddressList(params:any){
      const url = baseURL + `pay/billing-address/list`
      return service.get(url, params, header);
    },
    getAddressDefault(params:any){
      const url = baseURL + `member/address/get-default`
      return service.get(url, params, header);
    },
    getAddressById(params:any){
      const url = baseURL + `pay/billing-address/${params.id}`
      return service.get(url, params, header);
    },
    deleteAddressById(data:any){
      const url = baseURL + `pay/billing-address/delete`
      return service.delete(url, data, header);
    },
    createAddress(data:any){
      const url = baseURL + `pay/billing-address/create`
      return service.post(url, data, header);
    },
    updateAddress(data:any){
      const url = baseURL + `pay/billing-address/update`
      return service.put(url, data, header);
    },
    searchCountryByName(data:any){
      const url = baseURL + `pay/billing-country/by-country-name`
      return service.get(url, data, header);
    },
    getCountryById(data:any){
      const url = baseURL + `pay/billing-country/{id}`
      return service.get(url, data, header);
    },
    getCountryList(data:any){
      const url = baseURL + `pay/billing-country/list`
      return service.get(url, data, header);
    },
    getOrderDetail(params:any){
      const url = baseURL + `trade/order/get-detail`
      return service.get(url, params, header);
    },
    getAccountByPubKey(keys:any){
      const url = amaxNodeApi + `/v1/chain/get_accounts_by_authorizers`
      return service.post(url, {
        keys
      }, header);
    },
    getPubkeyByAccount(account_name:string){
      const url = amaxNodeApi + `/v1/chain/get_account`
      return service.post(url, {
        account_name
      }, header);
    },
    getTableRows(code:any,table:any){
      const url = amaxNodeApi + `/v1/chain/get_table_rows`
      return service.post(url, {
        code,
        scope: code,
        table: table,
        json: true,
      }, header);
    },
    getUserStake(accountName:any){
      const url = amaxNodeApi + `/v1/chain/get_table_rows`
      return service.post(url, {
        code:import.meta.env.VITE_APP_STAKE_NAME,
        scope:import.meta.env.VITE_APP_STAKE_NAME,
        table:'usrstake',
        key_type: "i64",
        lower_bound: accountName,
        upper_bound: accountName,
        json: true,
      }, header);
    },
   
    getBalanceByUser(data:any) {
      const url = amaxNodeApi + '/v1/chain/get_currency_balance'
      return service.post(url,data, header);
    },
    uploadImg(data:any) {
      const url = baseURL +`infra/file/upload`
      return service.post(url,data, header);
    },
    uploadOrderImg(data:any) {
      const url = baseURL +`infra/file/order/upload`
      return service.post(url,data, header);
    },
    getPayOrderDetail(params:any){
      const url = baseURL + `pay/order/get`
      return service.get(url, params, header);
    },
    getUserOrderList(params:any) {
      const url = baseURL + `trade/order/page`
      return service.get(url,params,header);
    },
    getMallPay(){
      const url = amaxNodeApi + `/v1/chain/get_table_rows`
      return service.post(url, {
        code:import.meta.env.VITE_APP_PAY,
        scope: import.meta.env.VITE_APP_PAY,
        table: 'global',
        json: true,
      }, header);
    }
}

//导出
export default _service